import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import styles from './DocflowBanner.module.scss'
import { getInbox } from 'service/DocflowService'

export default function DocflowBanner() {
  const navigate = useNavigate()
  const [unread, setUnread] = useState(0)

  useEffect(() => {
    getInbox()
      .then(r => {
        const count = (r.data || []).filter(d => !d.is_read).length
        setUnread(count)
      })
      .catch(() => {})
  }, [])

  return (
    <div className={styles.banner}>
      <div className={styles.left}>
        <span className={styles.icon}>📋</span>
        <div>
          <span className={styles.title}>Документооборот</span>
          <span className={styles.desc}>Служебные документы, резолюции, подписи</span>
        </div>
      </div>
      <div className={styles.right}>
        {unread > 0 && (
          <span className={styles.badge}>{unread} входящих</span>
        )}
        <button className={styles.btn} onClick={() => navigate('/docflow/')}>
          Открыть →
        </button>
      </div>
    </div>
  )
}
